<template>
  <div class="login-box">
    <logo></logo>
    <div class="login-box-body">
      <p class="login-box-msg"></p>
      <p v-html="$t('forgot_password.confirmation.text')"></p>
      <div class="row">
        <div class="col-xs-1"></div>
        <div class="col-xs-10">
          <router-link :to="{ name: 'login', query: logoUrlQueryParams }">{{ $t('forgot_password.confirmation.back') }}</router-link>
        </div>
        <div class="col-xs-1"></div>
      </div>
    </div>
  </div>
</template>

<script>
import urlQueryParams from '../mixins/logo-url-query-params'
import Logo from '../components/common/Logo'

// noinspection JSUnusedGlobalSymbols
export default {
  mixins: [urlQueryParams],
  components: {
    Logo
  }
}
</script>
